import { PropsWithChildren, ReactNode } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { getIsSupercellTemplate } from '../../../../utils/get-is-supercell-template';
import { usePaymentState } from '../../hooks/use-payment-state';

interface PaymentElementContainerProps {
  content: ReactNode;
}

const IS_SUPERCELL_TEMPLATE = getIsSupercellTemplate();

export function PaymentElementContainer({
  children,
  content,
}: PropsWithChildren<PaymentElementContainerProps>) {
  const isPaymentLoading = usePaymentState((state) => state.isPaymentLoading);
  return (
    <Stack height={'100%'}>
      <Box className={isPaymentLoading ? 'pointer-not-allowed' : ''}>{content}</Box>
      <Box pt={IS_SUPERCELL_TEMPLATE ? 1.5 : 2}>{children}</Box>
    </Stack>
  );
}
